// ============================================
// СЛАЙДЕР ФОТОГРАФИЙ КАМПУСА (КАРУСЕЛЬ С СВАЙПАМИ)
// ============================================

// Глобальные переменные для слайдера кампуса
let campusSlides, campusPrevBtn, campusNextBtn, campusPagination, sliderContainer;
let currentCampusSlide = 0;
let isTransitioning = false; // Флаг только для переходов через клоны
let isAnimating = false; // Флаг для блокировки всех переходов во время анимации
const slideGap = 20; // отступ между слайдами

// Функция для получения ширины слайда в зависимости от размера экрана
function getSlideWidth() {
  if (window.innerWidth <= 768) {
    return 313; // ширина для 768px
  }
  if (window.innerWidth <= 1024) {
    return 411; // уменьшенная ширина для 1024px
  }
  return 548; // стандартная ширина
}

// Функция для получения шага переключения
function getSlideStep() {
  return getSlideWidth() + slideGap;
}

// Функция для получения времени transition в зависимости от размера экрана
function getTransitionDuration() {
  return window.innerWidth >= 1024 ? '0.2s' : '0.4s';
}

// Функция для получения времени transition в миллисекундах
function getTransitionDurationMs() {
  return window.innerWidth >= 1024 ? 200 : 400;
}

// Глобальная функция для обновления слайдера кампуса
function updateCampusSlider() {
  if (!campusSlides || !sliderContainer) return;
  
  const allSlides = campusSlides.querySelectorAll(".slide");
  const realSlides = campusSlides.querySelectorAll(".slide:not(.slide-clone)");
  if (allSlides.length === 0 || realSlides.length === 0) return;
  
  // Ограничиваем индекс реальными слайдами
  if (currentCampusSlide < 0) {
    currentCampusSlide = 0;
  }
  if (currentCampusSlide >= realSlides.length) {
    currentCampusSlide = realSlides.length - 1;
  }
  
  // Получаем актуальную ширину слайда и шаг в зависимости от размера экрана
  const currentSlideWidth = getSlideWidth();
  const currentSlideStep = getSlideStep();
  
  // Вычисляем центр контейнера и позиционируем активный слайд по центру
  const containerWidth = sliderContainer.offsetWidth;
  const slideCenterX = currentSlideWidth / 2;
  
  // При 1024px используем центр viewport для правильного центрирования первого слайда
  let centerX;
  if (window.innerWidth <= 1024) {
    // При 1024px центр viewport является центром для позиционирования
    centerX = window.innerWidth / 2;
  } else {
    // При 1025px+ используем центр контейнера
    centerX = containerWidth / 2;
  }
  
  // Вычисляем позицию активного слайда
  // Учитываем, что первые realSlides.length элементов в DOM - это клоны всех слайдов
  // Реальные слайды начинаются с индекса realSlides.length
  // После реальных слайдов идут еще раз клоны всех слайдов
  let translateX;
  
  // Индекс реального слайда в DOM (с учетом всех клонов в начале)
  const realSlideIndexInDOM = realSlides.length + currentCampusSlide;
  
  if (window.innerWidth <= 1024 && currentCampusSlide === 0) {
    // При 1024px для первого слайда: центрируем относительно viewport
    // Первый слайд должен быть по центру экрана, слева пусто
    const viewportCenter = window.innerWidth / 2;
    const containerRect = sliderContainer.getBoundingClientRect();
    const containerLeft = containerRect.left;
    // Позиция относительно левого края контейнера: центр viewport минус левый край контейнера минус половина слайда
    // Учитываем, что реальный первый слайд находится на позиции realSlides.length
    const activeSlideLeftPosition = realSlideIndexInDOM * currentSlideStep;
    const activeSlideCenterPosition = activeSlideLeftPosition + slideCenterX;
    translateX = viewportCenter - containerLeft - activeSlideCenterPosition;
  } else if (currentCampusSlide === 0) {
    // Для первого слайда при 1025px+: центр контейнера минус половина ширины слайда
    // Учитываем, что реальный первый слайд находится на позиции realSlides.length
    const activeSlideLeftPosition = realSlideIndexInDOM * currentSlideStep;
    const activeSlideCenterPosition = activeSlideLeftPosition + slideCenterX;
    translateX = centerX - activeSlideCenterPosition;
  } else {
    // Для остальных слайдов используем стандартную формулу
    const activeSlideLeftPosition = realSlideIndexInDOM * currentSlideStep;
    const activeSlideCenterPosition = activeSlideLeftPosition + slideCenterX;
    translateX = centerX - activeSlideCenterPosition;
  }
  
  // Добавляем плавную анимацию, если не идет переход через клоны
  // Всегда устанавливаем transition для обычных переходов
  if (!isTransitioning) {
    campusSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
  }
  campusSlides.style.transform = `translateX(${translateX}px)`;
  
  // Обновляем буллеты - активный кружок соответствует центральному слайду
  if (campusPagination) {
    const bullets = campusPagination.querySelectorAll(".campus-pagination-bullet");
    bullets.forEach((bullet, index) => {
      if (index < realSlides.length) {
        bullet.classList.toggle("active", index === currentCampusSlide);
      }
    });
  }
}

// JSON с URL сжатых WebP (сервер: Dir.glob по Gallery-site-650x475), см. data-campus-gallery-images
function getCampusGalleryFromServer() {
  if (typeof window.__campusGalleryImagesParsed !== "undefined") {
    return window.__campusGalleryImagesParsed;
  }
  const root = document.querySelector("[data-secondary-campus-gallery]");
  const script = root && root.querySelector("script[data-campus-gallery-images]");
  if (!script || !String(script.textContent || "").trim()) {
    window.__campusGalleryImagesParsed = null;
    return null;
  }
  try {
    window.__campusGalleryImagesParsed = JSON.parse(script.textContent);
    return window.__campusGalleryImagesParsed;
  } catch (e) {
    window.__campusGalleryImagesParsed = null;
    return null;
  }
}

function resolveCampusGalleryImageSrc(absolutePath) {
  const currentPath = window.location.pathname;
  let imagePath = typeof landingAssetPath === "function" ? landingAssetPath(absolutePath) : absolutePath;
  if (currentPath.includes("/kindergarten/") || currentPath.includes("/school/") || currentPath.match(/\/[^\/]+\/index\.html/)) {
    imagePath = "../" + imagePath;
  }
  return imagePath;
}

// Функция для загрузки фотографий в слайдер
// Зависит от: campusNames, categoryFolders, categoryFoldersTashkent, campusGalleryImages
function loadCampusImages(campusId, categoryId) {
  if (!campusSlides) return;

  if (typeof window.campusNames === "undefined" ||
      typeof window.categoryFolders === "undefined" ||
      typeof window.categoryFoldersTashkent === "undefined") {
    return;
  }

  const category = categoryId === "tgn" ? "territory" :
    categoryId === "int" ? "interior" :
      categoryId === "lessons" ? "classes" :
        categoryId === "events" ? "events" : "territory";

  // В JSON с сервера ключ таба «Уроки» — lessons; в campusGalleryImages — classes
  const jsonTabKey = category === "classes" ? "lessons" : category;
  const server = getCampusGalleryFromServer();
  let imageUrls = [];

  if (server && server[campusId] && Array.isArray(server[campusId][jsonTabKey]) && server[campusId][jsonTabKey].length) {
    imageUrls = server[campusId][jsonTabKey].map((url) => resolveCampusGalleryImageSrc(url));
  } else {
    if (typeof window.campusGalleryImages === "undefined") return;
    let folderName = category;
    if (campusId === "tashkent") {
      folderName = window.categoryFoldersTashkent[categoryId] || category;
    } else {
      folderName = window.categoryFolders[categoryId] || category;
    }
    const images = window.campusGalleryImages[campusId]?.[category] || [];
    imageUrls = images.map((imageName) =>
      resolveCampusGalleryImageSrc(`/landing_2025/src/img/Gallery-site-650x475/campuses/${campusId}/${folderName}/${imageName}`)
    );
  }

  // Очищаем текущие слайды
  campusSlides.innerHTML = "";

  // Создаем новые слайды
  imageUrls.forEach((imagePath) => {
    const slide = document.createElement("div");
    slide.className = "slide";
    const img = document.createElement("img");
    img.src = imagePath;
    img.alt = `${window.campusNames[campusId]} - ${category}`;
    slide.appendChild(img);
    campusSlides.appendChild(slide);
  });
  
  // Клонируем все слайды для бесконечного слайдера
  const realSlides = campusSlides.querySelectorAll(".slide");
  if (realSlides.length > 0) {
    // Клонируем все слайды и добавляем перед первым
    const fragmentBefore = document.createDocumentFragment();
    realSlides.forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add("slide-clone");
      fragmentBefore.appendChild(clone);
    });
    campusSlides.insertBefore(fragmentBefore, realSlides[0]);

    // Клонируем все слайды и добавляем после последнего
    realSlides.forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add("slide-clone");
      campusSlides.appendChild(clone);
    });
  }
  
  // Сбрасываем текущий слайд ПЕРЕД созданием пагинации
  currentCampusSlide = 0;
  
  // Обновляем пагинацию
  if (campusPagination) {
    campusPagination.innerHTML = "";
    imageUrls.forEach((_, index) => {
      const bullet = document.createElement("span");
      bullet.className = "campus-pagination-bullet" + (index === 0 ? " active" : "");
      bullet.addEventListener("click", () => {
        currentCampusSlide = index;
        updateCampusSlider();
        // Обновляем пагинацию
        const bullets = campusPagination.querySelectorAll(".campus-pagination-bullet");
        bullets.forEach((b, i) => {
          b.classList.toggle("active", i === currentCampusSlide);
        });
      });
      campusPagination.appendChild(bullet);
    });
  }
  
  // Обновляем слайдер после загрузки изображений
  // Используем двойной setTimeout для гарантии, что DOM полностью обновлен
  setTimeout(() => {
    currentCampusSlide = 0; // Убеждаемся, что индекс = 0
    updateCampusSlider();
    // Обновляем пагинацию еще раз, чтобы активный кружок был правильным
    if (campusPagination) {
      const bullets = campusPagination.querySelectorAll(".campus-pagination-bullet");
      bullets.forEach((bullet, index) => {
        bullet.classList.toggle("active", index === 0);
      });
    }
  }, 150);
}

// Инициализация слайдера кампуса
function initCampusSlider() {
  // Средняя/старшая: тот же блок #block5 с data-secondary-campus-gallery — инициализируем как на главной
  if (document.body.classList.contains("middle-high-page") && !document.querySelector("[data-secondary-campus-gallery]")) {
    return;
  }
  campusSlides = document.getElementById("slides");
  campusPrevBtn = document.getElementById("campusPrev");
  campusNextBtn = document.getElementById("campusNext");
  campusPagination = document.getElementById("campusPagination");
  sliderContainer = document.querySelector(".slider_container");

  if (campusSlides && campusPagination && sliderContainer) {
    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let initialTranslate = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let touchInitialTranslate = 0;

    // Функция для получения реальных слайдов (без клонов)
    function getRealSlides() {
      return campusSlides.querySelectorAll(".slide:not(.slide-clone)");
    }

    // Функция для клонирования всех слайдов (все перед первым, все после последнего)
    function cloneSlides() {
      const realSlides = getRealSlides();
      if (realSlides.length === 0) return;

      // Удаляем старые клоны, если они есть
      const oldClones = campusSlides.querySelectorAll(".slide-clone");
      oldClones.forEach(clone => clone.remove());

      // Клонируем все слайды и добавляем перед первым
      const fragmentBefore = document.createDocumentFragment();
      realSlides.forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.classList.add("slide-clone");
        fragmentBefore.appendChild(clone);
      });
      campusSlides.insertBefore(fragmentBefore, realSlides[0]);

      // Клонируем все слайды и добавляем после последнего
      realSlides.forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.classList.add("slide-clone");
        campusSlides.appendChild(clone);
      });
    }

    // Функция для обновления пагинации
    function updatePagination() {
      campusPagination.innerHTML = "";
      const realSlides = getRealSlides();
      realSlides.forEach((_, index) => {
        const bullet = document.createElement("span");
        bullet.className = "campus-pagination-bullet" + (index === currentCampusSlide ? " active" : "");
        bullet.addEventListener("click", () => goToCampusSlide(index));
        campusPagination.appendChild(bullet);
      });
    }

    function goToCampusSlide(index) {
      const realSlides = getRealSlides();
      if (index < 0) index = 0;
      if (index >= realSlides.length) index = realSlides.length - 1;
      currentCampusSlide = index;
      updateCampusSlider();
      updatePagination();
    }

    // Функция для перехода на следующий слайд (с циклическим переходом через клоны)
    function goToNextSlide() {
      // Блокируем все переходы во время анимации
      if (isAnimating) return;
      
      const realSlides = getRealSlides();
      const realSlidesCount = realSlides.length;
      
      // Всегда переходим на следующий слайд, используя циклическую логику
      if (currentCampusSlide < realSlidesCount - 1) {
        // Обычный переход на следующий слайд
        isAnimating = true; // Блокируем дальнейшие переходы
        currentCampusSlide++;
        if (campusSlides.style.transition === 'none') {
          campusSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
        }
        updateCampusSlider();
        updatePagination();
        
        // Снимаем блокировку после завершения анимации
        setTimeout(() => {
          isAnimating = false;
        }, getTransitionDurationMs());
      } else {
        // Переход с последнего на первый через клон (циклический)
        if (isTransitioning || isAnimating) return; // Блокируем во время анимации
        isTransitioning = true;
        isAnimating = true; // Блокируем все переходы во время циклической анимации
        
        const firstCloneIndex = realSlidesCount * 2;
        const currentSlideStep = getSlideStep();
        const containerWidth = sliderContainer.offsetWidth;
        const currentSlideWidth = getSlideWidth();
        const slideCenterX = currentSlideWidth / 2;
        const activeSlideLeftPosition = firstCloneIndex * currentSlideStep;
        const activeSlideCenterPosition = activeSlideLeftPosition + slideCenterX;
        
        let translateX;
        if (window.innerWidth <= 1024) {
          const viewportCenter = window.innerWidth / 2;
          const containerRect = sliderContainer.getBoundingClientRect();
          const containerLeft = containerRect.left;
          translateX = viewportCenter - containerLeft - activeSlideCenterPosition;
        } else {
          const centerX = containerWidth / 2;
          translateX = centerX - activeSlideCenterPosition;
        }
        
        campusSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
        campusSlides.style.transform = `translateX(${translateX}px)`;
        
        setTimeout(() => {
          campusSlides.style.transition = 'none';
          currentCampusSlide = 0;
          updateCampusSlider();
          updatePagination();
            requestAnimationFrame(() => {
              setTimeout(() => {
                isTransitioning = false;
                isAnimating = false; // Снимаем блокировку после циклического перехода
                campusSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
              }, 0.0001);
            });
        }, getTransitionDurationMs());
      }
    }

    // Функция для перехода на предыдущий слайд (с циклическим переходом через клоны)
    function goToPrevSlide() {
      // Блокируем все переходы во время анимации
      if (isAnimating) return;
      
      const realSlides = getRealSlides();
      const realSlidesCount = realSlides.length;
      
      // Всегда переходим на предыдущий слайд, используя циклическую логику
      if (currentCampusSlide > 0) {
        // Обычный переход на предыдущий слайд
        isAnimating = true; // Блокируем дальнейшие переходы
        currentCampusSlide--;
        if (campusSlides.style.transition === 'none') {
          campusSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
        }
        updateCampusSlider();
        updatePagination();
        
        // Снимаем блокировку после завершения анимации
        setTimeout(() => {
          isAnimating = false;
        }, getTransitionDurationMs());
      } else {
        // Переход с первого на последний через клон (циклический)
        if (isTransitioning || isAnimating) return; // Блокируем во время анимации
        isTransitioning = true;
        isAnimating = true; // Блокируем все переходы во время циклической анимации
        
        const lastCloneIndex = realSlidesCount - 1;
        const currentSlideStep = getSlideStep();
        const containerWidth = sliderContainer.offsetWidth;
        const currentSlideWidth = getSlideWidth();
        const slideCenterX = currentSlideWidth / 2;
        const activeSlideLeftPosition = lastCloneIndex * currentSlideStep;
        const activeSlideCenterPosition = activeSlideLeftPosition + slideCenterX;
        
        let translateX;
        if (window.innerWidth <= 1024) {
          const viewportCenter = window.innerWidth / 2;
          const containerRect = sliderContainer.getBoundingClientRect();
          const containerLeft = containerRect.left;
          translateX = viewportCenter - containerLeft - activeSlideCenterPosition;
        } else {
          const centerX = containerWidth / 2;
          translateX = centerX - activeSlideCenterPosition;
        }
        
        campusSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
        campusSlides.style.transform = `translateX(${translateX}px)`;
        
        setTimeout(() => {
          campusSlides.style.transition = 'none';
          currentCampusSlide = realSlidesCount - 1;
          updateCampusSlider();
          updatePagination();
            requestAnimationFrame(() => {
              setTimeout(() => {
                isTransitioning = false;
                isAnimating = false; // Снимаем блокировку после циклического перехода
                campusSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
              }, 0.0001);
            });
        }, getTransitionDurationMs());
      }
    }

    // Функции для кнопок навигации - используют те же функции, что и свайпы
    function nextCampusSlide() {
      goToNextSlide();
    }

    function prevCampusSlide() {
      goToPrevSlide();
    }

    // Инициализация
    cloneSlides();
    currentCampusSlide = 0;
    updatePagination();

    // Обработчики для стрелок
    if (campusPrevBtn) {
      campusPrevBtn.addEventListener("click", prevCampusSlide);
    }
    if (campusNextBtn) {
      campusNextBtn.addEventListener("click", nextCampusSlide);
    }

    // Функция для вычисления начальной позиции
    function getInitialTranslate() {
      const realSlides = getRealSlides();
      const containerWidth = sliderContainer.offsetWidth;
      const centerX = window.innerWidth <= 1024 ? window.innerWidth / 2 : containerWidth / 2;
      const currentSlideWidth = getSlideWidth();
      const currentSlideStep = getSlideStep();
      const slideCenterX = currentSlideWidth / 2;
      const realSlideIndexInDOM = realSlides.length + currentCampusSlide;
      const activeSlideLeftPosition = realSlideIndexInDOM * currentSlideStep;
      const activeSlideCenterPosition = activeSlideLeftPosition + slideCenterX;
      
      if (window.innerWidth <= 1024 && currentCampusSlide === 0) {
        const viewportCenter = window.innerWidth / 2;
        const containerRect = sliderContainer.getBoundingClientRect();
        const containerLeft = containerRect.left;
        return viewportCenter - containerLeft - activeSlideCenterPosition;
      } else {
        return centerX - activeSlideCenterPosition;
      }
    }

    // Обработчики для свайпов (мышь)
    campusSlides.addEventListener("mousedown", (e) => {
      if (isTransitioning || isAnimating) return; // Блокируем во время анимации
      isDragging = true;
      startX = e.clientX;
      initialTranslate = getInitialTranslate();
      campusSlides.classList.add("dragging");
      e.preventDefault();
    });

    campusSlides.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      currentX = e.clientX - startX;
      campusSlides.style.transform = `translateX(${initialTranslate + currentX}px)`;
    });

    campusSlides.addEventListener("mouseup", () => {
      if (!isDragging) return;
      isDragging = false;
      campusSlides.classList.remove("dragging");
      
      // Адаптивный порог: для мобильных меньше, для десктопа больше
      const threshold = window.innerWidth <= 768 
        ? getSlideStep() / 6  // ~55px для мобильных (легче свайпать)
        : getSlideStep() / 5; // ~114px для десктопа (стандартный)
      if (Math.abs(currentX) > threshold) {
        if (currentX > 0) {
          goToPrevSlide();
        } else {
          goToNextSlide();
        }
      } else {
        updateCampusSlider();
      }
      currentX = 0;
    });

    campusSlides.addEventListener("mouseleave", () => {
      if (isDragging) {
        isDragging = false;
        campusSlides.classList.remove("dragging");
        updateCampusSlider();
        currentX = 0;
      }
    });

    // Обработчики для свайпов (тач)
    campusSlides.addEventListener("touchstart", (e) => {
      if (isTransitioning || isAnimating) return; // Блокируем во время анимации
      isDragging = true;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchInitialTranslate = getInitialTranslate();
      campusSlides.classList.add("dragging");
    });

    campusSlides.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      touchCurrentX = e.touches[0].clientX - touchStartX;
      const touchCurrentY = e.touches[0].clientY - touchStartY;
      
      // Уменьшили минимальное расстояние для начала свайпа с 10px до 5px
      if (Math.abs(touchCurrentX) > Math.abs(touchCurrentY) && Math.abs(touchCurrentX) > 5) {
        e.preventDefault();
      }
      
      // Для экранов >1023px картинка следует за пальцем, для ≤1023px - только отслеживаем расстояние
      if (window.innerWidth > 1023) {
        campusSlides.style.transform = `translateX(${touchInitialTranslate + touchCurrentX}px)`;
      }
    });

    campusSlides.addEventListener("touchend", () => {
      if (!isDragging) return;
      isDragging = false;
      campusSlides.classList.remove("dragging");
      
      // Адаптивный порог: для мобильных меньше, для десктопа больше
      const threshold = window.innerWidth <= 768 
        ? getSlideStep() / 6  // ~55px для мобильных (легче свайпать)
        : getSlideStep() / 5; // ~114px для десктопа (стандартный)
      if (Math.abs(touchCurrentX) > threshold) {
        if (touchCurrentX > 0) {
          goToPrevSlide();
        } else {
          goToNextSlide();
        }
      } else {
        updateCampusSlider();
      }
      touchCurrentX = 0;
    });

    // Инициализация и обновление при изменении размера окна
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        cloneSlides();
        updateCampusSlider();
      }, 100);
    });

    // Инициализация
    currentCampusSlide = 0;
    const initialSlides = campusSlides.querySelectorAll(".slide");
    if (initialSlides.length > 0) {
      updateCampusSlider();
    }
    
    window.addEventListener('load', () => {
      currentCampusSlide = 0;
      updateCampusSlider();
    });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCampusSlider);
} else {
  initCampusSlider();
}

// Экспортируем функции глобально
window.updateCampusSlider = updateCampusSlider;
window.loadCampusImages = loadCampusImages;
